module.exports = __webpack_public_path__ + "static/media/plus-hexagon.acb7899a.svg";